import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import "./RPRightPanelComponent.scss";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import {
  getDeleteRolePlayDraft,
  getDeleteRolePlayDraftResponseClear,
  getSubmitRolePlayDraft,
  getSubmitRolePlayDraftResponseClear,
  relatedRolePlayList,
  relatedRolePlayListClear,
} from "../../../../redux/roleplay/actions";
import { SessionKeys } from "../../../../utils/AppUtils";
import _ from "lodash";
import RolePlayVideoCard from "../../../RolePlay/RolePlayVideoCard";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import UploadDraftComponent from "./UploadDraftComponent";
import ConfirmModal from "../../../modal/ConfirmModal";
import moment from "moment";
import { useTranslation } from "react-i18next";
const RPRightPanelComponent = ({
  video_id,
  reload,
  isCardClick,
  setIsCardClick,
  setSubmitId,
  setShowVideo,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [key, setKey] = useState("uploaded");
  const [relatedList, setRelatedList] = useState([]);
  const [relatedListDrafted, setRelatedListDrafted] = useState([]);
  const [userDetails, setUserDetails] = useState({});

  const [submittedRolePlayId, setSubmittedRolePlayId] = useState();
  const [deletedRolePlayId, setDeletedRolePlayId] = useState();
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [showGreenTick, setShowGreenTick] = useState(false);

  useEffect(() => {
    // console.log("userDetailRes: ", userDetailRes);
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);

  useEffect(() => {
    if (submittedRolePlayId) {
      submitDraftedRoleplay(submittedRolePlayId);
    }
  }, [submittedRolePlayId]);

  useEffect(() => {
    if (deletedRolePlayId) {
      deleteDraftedRoleplay(deletedRolePlayId);
    }
  }, [deletedRolePlayId]);

  const submitRoleplayDraftResponse = useSelector(
    (state) => state.rolePlay.submitRoleplayDraft
  );
  const deleteRoleplayDraftResponse = useSelector(
    (state) => state.rolePlay.deleteRoleplayDraft
  );

  const deleteDraftedRoleplay = (roleplay_id) => {
    setIsLoading(true);
    dispatch(
      getDeleteRolePlayDraft({
        module: "deleteRolePlayDraft",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: roleplay_id,
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(deleteRoleplayDraftResponse)) {
      if (deleteRoleplayDraftResponse?.status === "success") {
        callRelatedListAPI();
        setConfirmModal(true);
        setShowModalMsg(t("Successfully deleted."));
        setShowGreenTick(true);
      } else {
        setConfirmModal(false);
        setShowModalMsg(t("Unable to delete, please try again later."));
        setShowGreenTick(false);
      }
      dispatch(getDeleteRolePlayDraftResponseClear());
    }
  }, [deleteRoleplayDraftResponse]);

  useEffect(() => {
    if (!_.isEmpty(submitRoleplayDraftResponse)) {
      if (submitRoleplayDraftResponse?.status === "success") {
        callRelatedListAPI();
        setConfirmModal(true);
        setShowModalMsg(t("Submitted for review successfully."));
        setShowGreenTick(true);
      } else {
      }
      dispatch(getSubmitRolePlayDraftResponseClear());
    }
  }, [submitRoleplayDraftResponse]);

  const submitDraftedRoleplay = (roleplay_id) => {
    setIsLoading(true);
    dispatch(
      getSubmitRolePlayDraft({
        module: "submitRolePlayDraft",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: roleplay_id,
        },
      })
    );
  };

  const relatedRolePlayArr = useSelector(
    (state) => state.rolePlay.relatedRolePlayList
  );

  const format_duration = (duration) => {
    const [minutes, seconds] = duration.split(":");

    // const hoursInt = parseInt(hours, 10);
    const minutesInt = parseInt(minutes, 10);
    const secondsInt = parseInt(seconds, 10);

    if (minutesInt === 0 && secondsInt === 0) {
      return "0s";
    } else if (minutesInt === 0) {
      if (secondsInt > 9) {
        return `00m ${secondsInt}s`;
      } else {
        return `00m 0${secondsInt}s`;
      }
    } else {
      if (minutesInt > 9) {
        if (secondsInt > 9) {
          return `${minutesInt}m ${secondsInt}s`;
        } else {
          return `${minutesInt}m 0${secondsInt}s`;
        }
      } else {
        if (secondsInt > 9) {
          return `0${minutesInt}m ${secondsInt}s`;
        } else {
          return `0${minutesInt}m 0${secondsInt}s`;
        }
      }
    }
  };

  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dateObj = new Date(inputDate);
    const month = months[dateObj.getMonth()];
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  function formatTime(inputTime) {
    const [hours, minutes, seconds] = inputTime.split(":").map(Number);

    const meridiem = hours >= 12 ? "PM" : "AM";

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

    const formattedTime = `${formattedHours}:${minutes
      .toString()
      .padStart(2, "0")} ${meridiem}`;

    return formattedTime;
  }

  const timeAndDateConverter = (date) => {
    // return moment(date, 'YYYY-MM-DD HH:mm:ss').format('MMM DD, YYYY');
    let date1 = date.split(" ");
    let obj = {};
    obj.date = formatDate(date1[0]);
    obj.time = formatTime(date1[1]);
    return obj;
  };

  const reviewedDateConverter = (date) => {
    if (date) {
      // console.log(date)
      // const timestamp = date * 1000;

      // const date = new Date(timestamp);
      // const options = { year: "numeric", month: "short", day: "numeric" };

      // const formattedDate = date.toLocaleDateString("en-US", options);
      // return formattedDate;
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("MMM DD, YYYY");
    }
    return "";
  };

  useEffect(() => {
    if (!_.isEmpty(relatedRolePlayArr)) {
      if (relatedRolePlayArr.status === "success") {
        const data = relatedRolePlayArr.payload.payload;
        console.log("Related Array", data);
        if (_.isArray(data)) {
          let newArr = [];
          for (let role of data) {
            let totalPoint = 0;
            if (_.isArray(role.feedback_data)) {
              let data = role.feedback_data[0];
              totalPoint = calTotalPoint(data);
            } else if (!_.isEmpty(role.feedback_data)) {
              let data = role.feedback_data;
              totalPoint = calTotalPoint(data);
            }
            let feedbackData = _.isArray(role.feedback_data)
              ? role.feedback_data[0]
              : role.feedback_data;
            if (!_.isEmpty(role)) {
              newArr.push({
                roleplay_id: role.roleplay_id,
                title: role.roleplay_title,
                situation: role.situation,
                description: role.description,
                releaseDate: role.release_date,
                duration: role.duration,
                formattedDuration: format_duration(role.roleplay_duration),
                formattedDate:
                  role?.submission_status === "submitted"
                    ? reviewedDateConverter(role.submission_dt)
                    : "",
                formatReviewedDate: role?.reviewed_date
                  ? reviewedDateConverter(role?.reviewed_date)
                  : "",
                coach_name: role.coach_name,
                durationUnit: role.durationUnit,
                userFirstName: role.user_first_name,
                userLastName: role.user_last_name,
                type: role.uploaded_type,
                originalType: role.type,
                url: role.url,
                originalURL: role.url,
                thumbnail: role.thumbnail,
                uploaded_file: role.roleplay_video_or_doc_path,
                submissionDate: role.submission_dt,
                submissionStatus: role.submission_status,
                createdDate: role.created_dt,
                brokerageId: role.brokerage_id,
                userId: role.user_id,
                role_play_id: role.reference_video_id,
                uploadedType: role.uploaded_type,
                submitToCoach: _.toNumber(role.submit_to_coach),
                coach_id: role.coach_id,
                additionalComment: role.additional_comment,
                roleplay_category: role.roleplay_category,
                roleplay_url: role.roleplay_url,
                roleplay_wpm: role.roleplay_wpm,
                roleplay_duration: role.roleplay_duration,
                roleplay_sentiment_positive: role.roleplay_sentiment_positive,
                roleplay_sentiment_negative: role.roleplay_sentiment_negative,
                roleplay_sentiment_neutral: role.roleplay_sentiment_neutral,
                roleplay_keywords: role.roleplay_keywords,
                // ? JSON.parse(role.roleplay_keywords)
                // : [],
                roleplay_keyword_analysis: role.roleplay_keyword_analysis,
                // ? JSON.parse(role.roleplay_keyword_analysis)
                // : [],
                roleplay_score: totalPoint,

                isFeedbackPresent: !_.isEmpty(feedbackData) ? true : false,
                feedbackData,
              });
            }
          }
          let newArrUploaded = [];
          let newArrDrafted = [];
          for (let role of newArr) {
            if (role?.submissionStatus === "submitted") {
              newArrUploaded.push(role);
            } else if (role?.submissionStatus === "drafted") {
              newArrDrafted.push(role);
            }
          }
          setRelatedList(newArrUploaded);
          setRelatedListDrafted(newArrDrafted);
        } else {
          setRelatedList([]);
          setRelatedListDrafted([]);
        }
      } else {
        setRelatedList([]);
        setRelatedListDrafted([]);
      }
      setIsLoading(false);
      dispatch(relatedRolePlayListClear());
    }
  }, [relatedRolePlayArr]);

  const callRelatedListAPI = () => {
    setIsLoading(true);
    dispatch(
      relatedRolePlayList({
        module: "roleplayRelateList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          video_id: video_id,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  useEffect(() => {
    callRelatedListAPI();
    return () => {
      dispatch(relatedRolePlayListClear());
    };
  }, [video_id, key, activeLanguage]);

  useEffect(() => {
    if (reload) {
      callRelatedListAPI();
    }
    return () => {
      dispatch(relatedRolePlayListClear());
    };
  }, [reload]);

  const calTotalPoint = (data) => {
    return (
      _.toNumber(data.awareness_star) +
      _.toNumber(data.research_star) +
      _.toNumber(data.impact_star) +
      _.toNumber(data.empathy_star)
    );
  };

  useEffect(() => {
    setKey(key);
  }, [key]);

  const [isLoading, setIsLoading] = useState(true);
  var noSavedRecord = "No Saved Recordings Yet.";
  var noList = "No List";
  const [selectedRP, setSelectedRP] = useState("");

  return (
    <div className="contsection rp-right-panel">
      <Tabs
        underline
        activeKey={key}
        onSelect={(k) => {
          setIsLoading(true);
          setKey(k);
        }}
      >
        <Tab eventKey={"uploaded"} title={t("Uploaded")}>
          {isLoading ? (
            <div className="recording-sec cursor-pointer">
              <div className="video-box position-relative">
                <ShimmerScreen case={"rect"} height="4rem" width="100%" />
              </div>
              <div className="video-details-role">
                <div className="video-title-role">
                  <ShimmerScreen case="rect" height="2rem" width="100%" />
                </div>
                <div className="video-rating-role">
                  <p className="setimatetitle">
                    <ShimmerScreen case="rect" height="1.5rem" width="100%" />
                  </p>
                  <div className="d-flex ratings-role mt-3">
                    <div className="rolerate">
                      <ShimmerScreen case="rect" height="2rem" width="100%" />
                    </div>
                    <div className="rolerate">
                      <ShimmerScreen case="rect" height="2rem" width="100%" />
                    </div>
                    <div className="rolerate">
                      <ShimmerScreen case="rect" height="2rem" width="100%" />
                    </div>
                  </div>
                </div>
                <div className="videotiming-role d-flex">
                  <div className="videotimebox">
                    <ShimmerScreen case="rect" height="2rem" width="100%" />
                  </div>
                  <div className="videotimebox">
                    <ShimmerScreen case="rect" height="2rem" width="100%" />
                  </div>
                </div>
              </div>
            </div>
          ) : relatedList?.length === 0 ? (
            <NotFoundComponent
              width="200"
              height="210"
              showBtn={false}
              btnName=""
              btnAction={() => {}}
              showMsg={true}
              msgLine={t("No role plays yet.")}
            />
          ) : _.isArray(relatedList) ? (
            relatedList.length > 0 ? (
              relatedList.map((roleList, i) => {
                return (
                  <UploadDraftComponent
                    key={`rolelist-${i + 1}`}
                    roleInfo={roleList}
                    uploaded={true}
                    isCardClick={isCardClick}
                    setIsCardClick={setIsCardClick}
                    type={"uploaded"}
                    setSubmitId={setSubmitId}
                    setShowVideo={setShowVideo}
                    // onDraftDelete={setDeletedRolePlayId}
                    // onDraftSubmit={setSubmittedRolePlayId}
                  />
                );
              })
            ) : (
              <p className="norecordings">{noSavedRecord}</p>
            )
          ) : (
            <p className="norecordings">{noList}</p>
          )}
        </Tab>
        <Tab eventKey={"drafts"} title={t("Drafts")}>
          {isLoading ? (
            <div className="recording-sec cursor-pointer">
              <div className="video-box position-relative">
                <ShimmerScreen case={"rect"} height="4rem" width="100%" />
              </div>
              <div className="video-details-role">
                <div className="video-title-role">
                  <ShimmerScreen case="rect" height="2rem" width="100%" />
                </div>
                <div className="video-rating-role">
                  <p className="setimatetitle">
                    <ShimmerScreen case="rect" height="1.5rem" width="100%" />
                  </p>
                  <div className="d-flex ratings-role mt-3">
                    <div className="rolerate">
                      <ShimmerScreen case="rect" height="2rem" width="100%" />
                    </div>
                    <div className="rolerate">
                      <ShimmerScreen case="rect" height="2rem" width="100%" />
                    </div>
                    <div className="rolerate">
                      <ShimmerScreen case="rect" height="2rem" width="100%" />
                    </div>
                  </div>
                </div>
                <div className="videotiming-role d-flex">
                  <div className="videotimebox">
                    <ShimmerScreen case="rect" height="2rem" width="100%" />
                  </div>
                  <div className="videotimebox">
                    <ShimmerScreen case="rect" height="2rem" width="100%" />
                  </div>
                </div>
              </div>
            </div>
          ) : relatedListDrafted?.length === 0 ? (
            <NotFoundComponent
              width="200"
              height="210"
              showBtn={false}
              btnName=""
              btnAction={() => {}}
              showMsg={true}
              msgLine={t("No role plays yet.")}
            />
          ) : _.isArray(relatedListDrafted) ? (
            relatedListDrafted.length > 0 ? (
              relatedListDrafted.map((roleList, i) => {
                return (
                  <UploadDraftComponent
                    key={`rolelist-${i + 1}`}
                    roleInfo={roleList}
                    uploaded={false}
                    onDraftDelete={setDeletedRolePlayId}
                    onDraftSubmit={setSubmittedRolePlayId}
                    isCardClick={isCardClick}
                    setIsCardClick={setIsCardClick}
                    type={"drafted"}
                    userDetails={userDetails}
                    setSubmitId={setSubmitId}
                    setShowVideo={setShowVideo}
                  />
                );
              })
            ) : (
              <p className="norecordings">{noSavedRecord}</p>
            )
          ) : (
            <p className="norecordings">{noList}</p>
          )}
        </Tab>
      </Tabs>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={false}
        confirmId={""}
        confirmAction={() => {}}
        isRightIcon={showGreenTick}
      />
    </div>
  );
};

export default RPRightPanelComponent;
